import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  Grid,
  TextField
} from "@material-ui/core";
import Controls from "./controls/Controls";
import { useState } from "react";
import { useEffect } from "react";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import { Form, useForm } from "./useForm";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(4),
    position: "absolute",
    top: theme.spacing(5),
    width:'20%',
    height:'70%'
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  
  },
  dialogAction: {
    justifyContent: "center",
   
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

export default function ConfirmDialog(props) {
  const [fundoption, setFundoption] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [Banks, setBanks] = useState([]);
  const [image, setImage] = useState("");
  const { confirmDialog, setConfirmDialog } = props;
  const classes = useStyles();
  const staff_type = localStorage.getItem("staff_type");
  const [loadingFatora, setLoadingFatora] = useState(false);
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);
  const [discount_fatora_bank, setDiscount_fatora_bank] = useState([]);
  const [increase_sell_percent, setIncrease_sell_percent] = useState([]);
  useEffect(() => {}, [props.id]);
  useEffect(() => {
    if (loadingFatora === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoadingFatora(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loadingFatora]);
  // useEffect(() => {
  //   getAllPaymentMethods().then((res) => {
  //     setPaymentMethod(res.data);
  //   });
  //   getAllBanks().then((res) => {
  //     setBanks(res);
  //   });
  //   getEPaymentConfig().then((res) => {
  //     setGetPaymentconfigration(res);

  //     // setIsLoading(true);
  //   });
  //   return () => {};
  // }, []);
  const [searchQuery, setSearchQuery] = useState(""); // State to hold the search query

  // Function to handle search query change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filtered list based on search query
  const filteredData = Array.isArray(props.data2) ? props.data2.filter(
    (data) =>
      data.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (data.description && data.description.toLowerCase().includes(searchQuery.toLowerCase()))
  ) : [];

  const initialFValues = {
    phone: props.phone,
    description: "",
  };

  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("description" in fieldValues) {
      if (fieldValues.description == "") {
        temp.description = "هذا الحقل مطلوب";
      } else {
        temp.description = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };

  const { loginInput, setLogin, errors, setErrors, handleInputChange } =
    useForm(initialFValues, true.validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const data = {
        phone: initialFValues.phone,
        description: loginInput.description,
      };

      axios
        .post(`${BaseUrl}/api/addToMyCustomer`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status == true) {
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          } else if (res.data.status == false) {
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          } else {
            sweetalert(loginInput.error_list);
            setLogin({ ...loginInput, error_list: res.data.message });
          }
        });
    }
  };
function handeladdMobile(mobile){
localStorage.setItem("convert_mobile", mobile);
setConfirmDialog({ ...confirmDialog, isOpen: false })

 }

  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }} >
      {/* <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent> */}
  
      <DialogActions
        className={classes.dialogAction}
        style={{ display: "flex", flexDirection: "column" }}
      >
           <Typography variant="h6"  style={{ marginBottom: "20px"}} >{confirmDialog.title}</Typography>
           <TextField
          // variant="outlined"
          fullWidth
          placeholder="بحث عن طريق الاسم أو رقم الموبايل"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{ marginBottom: "20px" ,padding:'10.5px 14px !important'}} // Add some spacing below the search box
        />
       <Form className="form-group new-design" onSubmit={handleSubmit} style={{ width: '100%' }}>
          {Array.isArray(filteredData) && filteredData.length > 0 ? (
            filteredData.map((data, i) => (
              <>

              <Grid item lg={12} md={12} xs={12} key={i} style={{display:'flex', justifyContent:'space-between'}} >
                <Grid item lg={6} md={6} >
                  {data.description}
                </Grid>
                <Grid item lg={6} md={6} style={{display:'flex', justifyContent:'center' , cursor:'pointer'}} onClick={()=>handeladdMobile(data.phone)}>
                  {data.phone}
                </Grid>
              </Grid>
              <hr></hr>
              </>
            ))
          ) : (
            <></>
          )}
          <Grid item lg={12} md={12} xs={12} style={{display:'flex', justifyContent:'center', marginTop: "15px"}} >
            <Controls.Button
              text="إغلاق"
              color="default"
              onClick={() =>
                setConfirmDialog({ ...confirmDialog, isOpen: false })
              }
            />
          </Grid>
        </Form>
      </DialogActions>
    </Dialog>
  );
}
